<div
  class="toast--wrapper toast--wrapper-position-{{ position }}"
  *ngIf="toastService.messages().length"
>
  <div class="toast--item" *ngFor="let message of toastService.messages()">
    <svg
      *ngIf="message.type === ToastType.ERROR"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"
        fill="#F5BCC5"
      />
    </svg>
    <svg
      *ngIf="message.type === ToastType.INFO"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2806_499)">
        <path
          d="M9.00014 16.17L5.53014 12.7C5.14014 12.31 4.51014 12.31 4.12014 12.7C3.73014 13.09 3.73014 13.72 4.12014 14.11L8.30014 18.29C8.69014 18.68 9.32014 18.68 9.71014 18.29L20.2901 7.71C20.6801 7.32 20.6801 6.69 20.2901 6.3C19.9001 5.91 19.2701 5.91 18.8801 6.3L9.00014 16.17Z"
          fill="#14E25A"
        />
      </g>
      <defs>
        <clipPath id="clip0_2806_499">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>

    <p class="toast--text toast--text-{{ message.type }}">
      {{ message.message }}
    </p>
  </div>
</div>
